<template>
  <div class="flex-grid">
    <Confirm
      :text="deleteText"
      :is-visible="isDelete"
      @onConfirm="onConfirm"
    />
    <div class="col1">
      <div class="main_heading">
        <h3>Manage Fascia Groups</h3>
        <a
          class="button_create"
          href="/createfasciaGroup/"
        >Create Fascia Group</a>
      </div>
      <v-client-table
        :columns="columns"
        :data="fasciaGroupsList"
        :options="options"
      >
        <template
          slot="actions"
          slot-scope="props"
        >
          <a
            :href="`/createfasciaGroup/?id=${props.row.id}`"
            class="glyphicon glyphicon-edit"
          />
          <a
            class="glyphicon glyphicon-trash"
            @click="deleteConfirm(props.row.id)"
          />
        </template>
      </v-client-table>
    </div>
  </div>
</template>
<script>
import Confirm from '@/components/Confirm.vue';

export default {
  name: 'FasciaGroups',
  components: {
    Confirm,
  },
  data() {
    return {
      columns: ['sno', 'name', 'status', 'actions'],
      options: {
        headings: {
          sno: '#',
          name: 'Group Name',
          status: 'Status',
          actions: 'Actions',
        },
        sortable: ['status', 'name'],
        filterable: ['status', 'name'],
      },
      isDelete: false,
      deleteText: 'Are You Sure Want To Delete?',
      fasciaGroupsList: [],
      currentGroup: '',
    };
  },
  mounted() {
    const getfasciaGroups = fetch('/api/fasciaGroups/all', {
      credentials: 'same-origin',
    });
    getfasciaGroups
      .then(data => data.json())
      .then((data) => {
        let fasciaGroupsArray = [];
        fasciaGroupsArray = data.map((group, i) => {
          const obj = {
            sno: i + 1,
            id: `${group._id}`,
            name: `${group.group_name}`,
            status: `${group.status}`,
          };
          return obj;
        });
        this.fasciaGroupsList = fasciaGroupsArray;
      });
  },
  methods: {
    deleteConfirm(id) {
      this.isDelete = true;
      this.currentGroup = id;
    },
    onConfirm(status) {
      this.isDelete = false;
      if (status === 'yes') {
        this.deletefasciaGroup(this.currentGroup);
      }
    },
    deletefasciaGroup(id) {
      const url = `/api/fasciaGroups/${id}`;
      fetch(url, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }))
        .then(
          this.fasciaGroupsList.splice(
            this.fasciaGroupsList.findIndex(fascia => fascia.id === id),
            1,
          ),
        );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col1 {
  width: 100%;
}
</style>
